import React, { useState } from "react";
import { FaWhatsapp, FaTimes } from "react-icons/fa";

const WhatsAppChat = () => {
  const [open, setOpen] = useState(false);

  const phoneNumber = "8124343494"; // change this
  const message = "Hi, I need help with your services";

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <>
      {/* Chat Box */}
      {open && (
        <div style={styles.chatBox}>
          <div style={styles.header}>
            <span>Chat with us</span>
            <FaTimes onClick={() => setOpen(false)} style={{ cursor: "pointer" }} />
          </div>

          <div style={styles.body}>
            <p>👋 Hi there!</p>
            <p>How can we help you?</p>
          </div>

          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={styles.button}
          >
            <FaWhatsapp /> Start Chat
          </a>
        </div>
      )}

      {/* Floating Button */}
      <div style={styles.floating} onClick={() => setOpen(!open)}>
        {open ? <FaTimes /> : <FaWhatsapp />}
      </div>
    </>
  );
};

const styles = {
  floating: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    backgroundColor: "#25D366",
    color: "#fff",
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "26px",
    cursor: "pointer",
    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
    zIndex: 1000,
  },

  chatBox: {
    position: "fixed",
    bottom: "90px",
    right: "20px",
    width: "280px",
    backgroundColor: "#fff",
    borderRadius: "10px",
    boxShadow: "0 5px 20px rgba(0,0,0,0.2)",
    overflow: "hidden",
    zIndex: 1000,
  },

  header: {
    backgroundColor: "#25D366",
    color: "#fff",
    padding: "10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontWeight: "bold",
  },

  body: {
    padding: "10px",
    fontSize: "14px",
  },

  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    backgroundColor: "#25D366",
    color: "#fff",
    textDecoration: "none",
    padding: "10px",
    fontWeight: "bold",
  },
};

export default WhatsAppChat;